// extracted by mini-css-extract-plugin
export default {"componentWrapper":"HtmlBlock_componentWrapper__6UvVj","title":"HtmlBlock_title__ZJV1f"};